/**
 *
 * @param timerEnd
 * @returns {import('@playlive/overlay-core').DonationWithTimerEffect[]}
 * @constructor
 */
export const SubathonTimerDonations = (
  timerEnd
) => {
  const getOffsetDate = (offset) => {
    const newDate = new Date(timerEnd);
    newDate.setTime(newDate.getTime() + offset);
    return newDate;
  };

  return [
    {
      id: 'donation-1',
      amount: {
        value: '5',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'John Doe',
      donor_comment: 'This is a test donation',
      campaign_id: 'campaign-1',
      cause_id: 'cause-1',
      timer_id: 'timer-1',
      timer_effect: {
        displayName: '+1m',
        timeDifference: 1000 * 60,
      },
      timer_end_date: getOffsetDate(1000 * 60),
    },
    {
      id: 'donation-2',
      amount: {
        value: '8',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'Steve Smith',
      donor_comment: 'This is a test donation',
      campaign_id: 'campaign-1',
      cause_id: 'cause-1',
      timer_id: 'timer-1',
      timer_effect: {
        displayName: '-1m',
        timeDifference: -1 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(-1 * 1000 * 60),
    },
    {
      id: 'donation-3',
      amount: {
        value: '25',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'Paul Lastname',
      donor_comment: 'This is a test donation',
      campaign_id: 'campaign-1',
      cause_id: 'cause-1',
      timer_id: 'timer-1',
      timer_effect: {
        displayName: '+2m',
        timeDifference: 2 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(2 * 1000 * 60),
    },
    {
      id: 'donation-4',
      amount: {
        value: '15',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'Alice Johnson',
      donor_comment: 'Keep up the great work!',
      campaign_id: 'campaign-2',
      cause_id: 'cause-2',
      timer_id: 'timer-2',
      timer_effect: {
        displayName: '+3m',
        timeDifference: 3 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(3 * 1000 * 60),
    },
    {
      id: 'donation-5',
      amount: {
        value: '10',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'Bob Brown',
      donor_comment: 'Happy to support!',
      campaign_id: 'campaign-2',
      cause_id: 'cause-2',
      timer_id: 'timer-2',
      timer_effect: {
        displayName: '-2m',
        timeDifference: -2 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(-2 * 1000 * 60),
    },
    {
      id: 'donation-6',
      amount: {
        value: '20',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'Charlie Davis',
      donor_comment: 'Great cause!',
      campaign_id: 'campaign-3',
      cause_id: 'cause-3',
      timer_id: 'timer-3',
      timer_effect: {
        displayName: '+4m',
        timeDifference: 4 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(4 * 1000 * 60),
    },
    {
      id: 'donation-7',
      amount: {
        value: '30',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'Diana Evans',
      donor_comment: 'Glad to help!',
      campaign_id: 'campaign-3',
      cause_id: 'cause-3',
      timer_id: 'timer-3',
      timer_effect: {
        displayName: '-3m',
        timeDifference: -3 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(-3 * 1000 * 60),
    },
    {
      id: 'donation-8',
      amount: {
        value: '50',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'Eve Foster',
      donor_comment: 'Wonderful initiative!',
      campaign_id: 'campaign-4',
      cause_id: 'cause-4',
      timer_id: 'timer-4',
      timer_effect: {
        displayName: '+5m',
        timeDifference: 5 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(5 * 1000 * 60),
    },
    {
      id: 'donation-9',
      amount: {
        value: '40',
        currency: 'USD',
      },
      completed_at: new Date().toISOString(),
      donor_name: 'Frank Green',
      donor_comment: 'Proud to contribute!',
      campaign_id: 'campaign-4',
      cause_id: 'cause-4',
      timer_id: 'timer-4',
      timer_effect: {
        displayName: '-4m',
        timeDifference: -4 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(-4 * 1000 * 60),
    },
    {
      id: 'donation-10',
      amount: {
        value: '60',
        currency: 'USD',
      },
      completed_at: getOffsetDate(0).toISOString(),
      donor_name: 'Grace Hill',
      donor_comment: 'Amazing effort!',
      campaign_id: 'campaign-5',
      cause_id: 'cause-5',
      timer_id: 'timer-5',
      timer_effect: {
        displayName: '+6m',
        timeDifference: 6 * 1000 * 60,
      },
      timer_end_date: getOffsetDate(6 * 1000 * 60),
    },
  ];
};